import { selectResource } from '../resource/resourceSelectors'

export const selectFilterData = state => selectResource(state)?.filters?.data
export const selectFilterDataIsLoading = state => selectResource(state)?.filters?.isLoading
